/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import type { PriceInfoType, CouponListType } from './types';
import { IProductItem } from '@/components/MembersDay/type';
import { getListProducts, getTotalPriceInfo, getListProducts2, getCouponListForMember } from '@/service/membersstore';
import type { ProductModule } from '@/components/MembersDay/type';
import { formatPrice } from '@/components/MembersDay/utils';
import { injectNotes } from '@/components/EcoCredits/utils';
import { FormatMoney } from '@/utils';

export const getDiscount = (original: number, current: number): string => {
    if (original === current) return '';
    const off = String(Math.round(((original - current) / original) * 100));
    return `${off}%`;
};

export const getEmailPrefix = (email: string) => {
    if (!email) return '';
    const match = email.match(/^([^\@]+)/);
    if (match) {
        return match[1];
    }
    return email;
};

export const useProductList = (module: ProductModule, locale: string) => {
    const [loading, setLoading] = useState(true);
    const [productList, setProductList] = useState<IProductItem[]>([]);

    useEffect(() => {
        getListProducts(
            {
                module,
                bizModule: 'MEMBER_STORE',
            },
            locale,
        )
            .then((res) => {
                if (res.code !== '0') return;
                res.data?.map((item: IProductItem) => {
                    if (parseInt(item.compareAtPrice) > parseInt(item.memberPrice)) {
                        item.discount = formatPrice(String(parseInt(item.compareAtPrice) - parseInt(item.memberPrice)), locale);
                        item.discount = `SAVE ${item.discount}`;
                    }
                    item.memberPrice2 = formatPrice(item.memberPrice, locale);
                    item.price2 = formatPrice(item.price, locale);
                    item.compareAtPrice2 = formatPrice(item.compareAtPrice, locale);
                });
                setProductList(res.data);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return { productList, loading };
};

export const useProductList2 = (module: ProductModule, locale: string) => {
    const [loading, setLoading] = useState(true);
    const [productList, setProductList] = useState<IProductItem[]>([]);

    useEffect(() => {
        getListProducts2(
            {
                module,
                bizModule: 'MEMBER_STORE',
            },
            locale,
        )
            .then((res) => {
                if (res.code !== '0') return;
                res.data?.map((item: IProductItem) => {
                    if (parseInt(item.compareAtPrice) > parseInt(item.memberPrice)) {
                        item.discount = formatPrice(String(parseInt(item.compareAtPrice) - parseInt(item.memberPrice)), locale);
                        item.discount = `SAVE ${item.discount}`;
                    }
                    item.memberPrice2 = formatPrice(item.memberPrice, locale);
                    item.price2 = formatPrice(item.price, locale);
                    item.compareAtPrice2 = formatPrice(item.compareAtPrice, locale);
                });
                setProductList(res.data);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return { productList, loading };
};

export const useTotalPrice = (locale: string, isLogin: boolean) => {
    const [priceInfo, setPriceInfo] = useState(null);

    useEffect(() => {
        if (isLogin) {
            getTotalPriceInfo(locale).then((res) => {
                if (res.code !== '0') return;
                setPriceInfo(res.data);
            });
        }
    }, [isLogin]);

    return { priceInfo };
};

export const getTotalPrice = (locale: string, callback: (value: PriceInfoType) => void, t: any) => {
    getTotalPriceInfo(locale).then((res) => {
        if (res.code !== '0') return;
        const flatRules = [res.data].map((item) => {
            let minimum_rule = '';
            if (item?.prerequisite === 'PRICES') {
                const price = parseInt(item.prerequisiteRange);
                const currencySymbol = item?.ruleWebsite?.currencySymbol || '';
                const prerequisiteRange = t('minimum_price', { price: currencySymbol + FormatMoney(price) });
                minimum_rule = prerequisiteRange;
            }
            if (item?.prerequisite === 'QUANTITY') {
                const num = parseInt(item.prerequisiteRange);
                const prerequisiteRange = t('minimum_num', { num });
                minimum_rule = prerequisiteRange;
            }
            return {
                ...item,
                minimum_rule,
            };
        });

        const rewardRedeemRules = injectNotes(flatRules || [], t, locale);
        callback && callback(rewardRedeemRules[0]);
    });
};

export const getRewards = (locale: string, callback: (value: CouponListType[]) => void, t: any) => {
    getCouponListForMember(locale).then((res) => {
        if (res.code !== '0') return;
        const data = injectNotes(res?.data || [], t, locale as string);
        callback && callback(data);
    });
};
